// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "vw-avp-hck-dga-customerui.chunk." + chunkId + ".js";
};